/* Quote Form Submit: only verified quote submissions; no customer/form data sent. */
(function () {
  'use strict';
  if (window.__abioQuoteTrackingReady ||
      window.location.pathname.replace(/\/$/, '') !== '/pages/service-and-repair-quote') return;
  var root = document.querySelector('[data-abio-quote-tracking]');
  var form = root && root.querySelector('form');
  var result = root && root.querySelector('[data-abio-quote-result]');
  if (!form || !result) return;
  window.__abioQuoteTrackingReady = true;

  var key = 'abio.quote.pending.v1';
  var ttl = 2 * 60 * 60 * 1000;
  var attempts = 0;
  var timer;
  var featureRequested = false;
  var finished = false;

  function allowed() {
    try {
      var p = window.Shopify && window.Shopify.customerPrivacy;
      return !!(p && p.marketingAllowed() && p.analyticsProcessingAllowed());
    } catch (_) { return false; }
  }
  function getPending() {
    try {
      var p = JSON.parse(window.sessionStorage.getItem(key) || 'null');
      if (!p || typeof p.id !== 'string' || !/^abio-quote-[a-zA-Z0-9-]+$/.test(p.id) ||
          typeof p.at !== 'number' || p.at > Date.now() || Date.now() - p.at > ttl) return null;
      return p;
    } catch (_) { return null; }
  }
  function putPending(p) {
    try {
      window.sessionStorage.setItem(key, JSON.stringify(p));
      return true;
    } catch (_) { return false; }
  }
  function stop() {
    finished = true;
    window.clearTimeout(timer);
    document.removeEventListener('visitorConsentCollected', onConsent);
  }
  function trySend() {
    if (finished || result.dataset.success !== 'true') return;
    var p = getPending();
    if (!p || p.sent) { stop(); return; }
    if (!allowed() || typeof window.gtag !== 'function') return;
    // Persist before dispatch to prevent duplicate events on refresh/back navigation.
    p.sent = true;
    if (!putPending(p)) { stop(); return; }
    try {
      window.gtag('event', 'conversion', {
        send_to: 'AW-18267220842/OrGoCN61mewcEOrWvoZE',
        value: 0.0,
        currency: 'USD',
        transaction_id: p.id
      });
      result.dataset.tracking = 'queued';
      stop();
    } catch (_) {
      p.sent = false;
      putPending(p);
    }
  }
  function tick() {
    if (finished) return;
    var shopify = window.Shopify;
    if (shopify && !shopify.customerPrivacy && typeof shopify.loadFeatures === 'function' &&
        !featureRequested) {
      featureRequested = true;
      shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], function (error) {
        if (!error) trySend();
      });
    }
    trySend();
    if (!finished && ++attempts < 120) timer = window.setTimeout(tick, 250);
  }
  function onConsent() {
    trySend();
    if (!finished) {
      window.clearTimeout(timer);
      attempts = 0;
      tick();
    }
  }

  // A recent valid submit is also required: a success URL alone cannot count.
  form.addEventListener('submit', function (event) {
    if (event.defaultPrevented || !form.checkValidity() || !allowed()) return;
    var id = window.crypto && typeof window.crypto.randomUUID === 'function'
      ? window.crypto.randomUUID()
      : Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
    putPending({id: 'abio-quote-' + id, at: Date.now(), sent: false});
  });
  document.addEventListener('visitorConsentCollected', onConsent);
  tick();
})();
